// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2b17afd9","455":"129c4a8a","977":"a7e1381c"}[chunkId] + ".chunk.js";
};